import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { FormattedDate, injectIntl, intlShape } from 'react-intl';

const AttendeeDateBlock = ({ booking = {}, intl }) => {
  const guestSchedule = _.get(booking, 'public_fields.guest_schedule');
  const bookingSchedule = _.get(booking, 'schedule');
  const displaySchedule = guestSchedule || bookingSchedule;
  const timeZoneName = _.get(booking, 'end.timezone.name');
  const timeZoneId = _.get(booking, 'end.timezone.id');

  const displayList = (displaySchedule || []).map((scheduleItem, i) => {
    const st = scheduleItem.start;
    const end = scheduleItem.end;
    const momentStart = moment(`${st.date.y}-${st.date.m}-${st.date.d} ${st.time.h}:${st.time.m}`, 'YYYY-MM-DD HH:mm');
    const momentEnd = moment(`${end.date.y}-${end.date.m}-${end.date.d} ${end.time.h}:${end.time.m}`, 'YYYY-MM-DD HH:mm');
    const friendlyStartDate = momentStart.format('ddd, MMM D, YYYY');
    const friendlyStartTime = intl.formatTime(moment(momentStart, 'LT'));
    const friendlyEndTime = intl.formatTime(moment(momentEnd, 'LT'));
    const nextDay = intl.formatMessage({ id: 'elements_forms.schedule.next_day', defaultMessage: '(next day)' });
    const endsNextDate = (momentEnd.format('YYYY-MM-DD') === momentStart.format('YYYY-MM-DD')) ? '' : ` ${nextDay}`;

    // create a dateTime object to pass to be momentified
    // ensures that regardless of user's timezone, we show the listing time in the listings timezone
    const dateTime = {'date': displaySchedule[i].start.date, 'time': displaySchedule[i].start.time};
    function momentifyDate (dateTime) {
      const { date, time } = dateTime;
      // uses global moment function
      const momentDateTime = momentTz.tz(`${date.y}-${date.m}-${date.d} ${time.h}:${time.m}`, 'YYYY-MM-DD HH:mm', timeZoneId);
      return momentDateTime;
    }

    if (1 < displaySchedule.length) {
      return (
        <div key={`${friendlyStartDate}-${i}`} data-testing-id="schedule-item">
          <span className="heavy" data-testing-id="schedule-date">
            <FormattedDate
              value={momentifyDate(dateTime)}
              year="numeric"
              month="short"
              day="numeric"
              weekday="short"
              timeZone={timeZoneId}
            />
          </span>
          <span data-testing-id="schedule-time">, { friendlyStartTime } - { friendlyEndTime } { timeZoneName } { endsNextDate }</span>
        </div>
      );
    }

    return (
      <div className="inline-block" key={`${friendlyStartDate}-${i}`} data-testing-id="schedule-item">
        <h6 className="margin-md-bottom" data-testing-id="schedule-date">
          <FormattedDate
            value={momentifyDate(dateTime)}
            year="numeric"
            month="short"
            day="numeric"
            weekday="short"
            timeZone={timeZoneId}
          />
        </h6>
        <p data-testing-id="schedule-time">{ friendlyStartTime } - { friendlyEndTime } { timeZoneName } { endsNextDate }</p>
      </div>
    );
  });

  return (
    <div className="attendee-date-block margin-xl-bottom" data-testing-id="attendee-date-block">
      { displayList }
    </div>
  );
};

AttendeeDateBlock.propTypes = {
  booking: PropTypes.object,
  intl: intlShape
};

export default injectIntl(AttendeeDateBlock);
